import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestOptions } from './interfaces/request.interface';
import { environment } from '@environments/environment';
import { IS_PUBLIC_API } from '@core/auth/interceptors/auth.context';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.URL;

  /**
   * Método genérico para GET.
   * Agregamos la opción de 'isPublic' para usar el auth-context fácilmente.
   */
  public get<T>(endpoint: string, options?: RequestOptions, isPublic = false): Observable<T> {
    return this.http.get<T>(`${this.api}${endpoint}`, {
      ...options,
      context: new HttpContext().set(IS_PUBLIC_API, isPublic)
    });
  }

  /**
   * Método para archivos.
   */
  public getFile(endpoint: string, isPublic = false): Observable<Blob> {
    return this.http.get(`${this.api}${endpoint}`, {
      responseType: 'blob',
      context: new HttpContext().set(IS_PUBLIC_API, isPublic)
    });
  }

  public post<T>(endpoint: string, body: any, isPublic = false): Observable<T> {
    return this.http.post<T>(`${this.api}${endpoint}`, body, {
      context: new HttpContext().set(IS_PUBLIC_API, isPublic)
    });
  }

  public put<T>(endpoint: string, body: any, isPublic = false): Observable<T> {
    return this.http.put<T>(`${this.api}${endpoint}`, body, {
      context: new HttpContext().set(IS_PUBLIC_API, isPublic)
    });
  }
}
